'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = false;

const successSlice = createSlice({
  name: 'success',
  initialState,
  reducers: {
    setSuccess: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setSuccess } = successSlice.actions;
export default successSlice.reducer;
export const successSelector = (state: RootState) => state.success;
